import * as React from 'react';
import {InputProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {TextInput} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const Input = React.forwardRef(
  (props: InputProps, ref: React.Ref<HTMLInputElement>): JSX.Element => {
    const {
      label,
      defaultValue,
      disabled,
      value,
      min,
      onChange,
      onBlur,
      type,
      onKeyDown,
      step,
      testid,
    } = props;

    return (
      <Wrapper>
        <TextInput
          label={label}
          defaultValue={defaultValue}
          value={value}
          min={min}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          type={type}
          appearance={disabled ? 'readonly' : 'default'}
          step={step}
          data-testid={testid}
          ref={ref}
        />
      </Wrapper>
    );
  }
);

const Wrapper = styled.div`
  input[type='number' i] {
    padding-inline-end: 0;

    /* Firefox */
    -moz-appearance: textfield;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
